import Select from "../../../components/Select/Select";
import Input from "../../../components/Input/Input";
import Button from "../../../components/Button/Button";

const statusOptions = [
  { id: "1", name: "Confirmation Awaited" },
  { id: "2", name: "Confirmed" },
  { id: "3", name: "Closed" },
  { id: "4", name: "Cancelled" },
  { id: "5", name: "Rescheduled" },
];

const AppointmentFilter = ({
  filters,
  onApplyFilter,
  onResetFilter,
  handleFilterChange,
  meetingAuthorityOptions = [],
}) => {
  return (
    <div className="row mb-2">
      <div className="col-md-3">
        <Select
          label={"Status"}
          name="status"
          value={filters.status}
          onChangeHandler={handleFilterChange}
          placeholder="Status"
          options={statusOptions}
        />
      </div>

      <div className="col-md-3">
        <Select
          label={"Meeting With"}
          name="meeting_with"
          value={filters.meeting_with}
          onChangeHandler={handleFilterChange}
          placeholder="Meeting With"
          options={meetingAuthorityOptions}
        />
      </div>

      <div className="col-md-2">
        <Input
          label={"From Date"}
          type="date"
          name="from_date"
          placeholder="From Date"
          value={filters.from_date}
          onChangeHandler={handleFilterChange}
        />
      </div>

      <div className="col-md-2">
        <Input
          label={"To Date"}
          type="date"
          name="to_date"
          placeholder="To Date"
          value={filters.to_date}
          onChangeHandler={handleFilterChange}
        />
      </div>

      <div className="col-md-2 d-flex align-items-end">
        <Button type="submit" variant="primary" className="me-2 mb-3" onClick={onApplyFilter}>
          Search
        </Button>

        <Button type="submit" variant="secondary" className="mb-3" onClick={onResetFilter}>
          Reset
        </Button>
      </div>
    </div>
  );
};

export default AppointmentFilter;
